export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-[#0a1628] via-[#0d1d35] to-[#0a1628] overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-teal-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-6 animate-fade-in">
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
              메이저 배팅 사이트<br />맞춤형 솔루션
            </h1>
            <p className="text-lg text-gray-300 leading-relaxed">
              풀 오토 스포츠 배팅, 온라인 카지노, 슬롯, 미니게임,<br />
              풀 오토 가상계좌 시스템 등 온라인 갬블링 사업에<br />
              필요한 모든 것이 개발되어 있습니다.
            </p>
            <div className="pt-4">
              <a 
                href="https://t.me/realtad_cs" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                텔레그램 문의
              </a>
            </div>
          </div>

          <div className="relative animate-fade-in-right">
            <img 
              src="https://winka.io/wp-content/uploads/2024/01/graphic-2.webp" 
              alt="Platform Preview" 
              className="w-full h-auto relative z-10"
            />
            <img 
              src="https://winka.io/wp-content/uploads/2024/02/graphic-7.webp" 
              alt="Decoration" 
              className="absolute -bottom-10 -left-10 w-48 h-auto animate-float"
            />
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
}